import { Chip } from '@mui/material';
import { grey, orange, blue, red, green } from '@mui/material/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ExamStatus } from 'shared/types';

const statusStyles: Record<ExamStatus, React.CSSProperties> = {
  sended: { backgroundColor: blue[500], color: '#FAF8F4' },
  completed: { backgroundColor: orange[500], color: '#FAF8F4' },
  readyToCheck: { backgroundColor: '#F65329', color: '#FAF8F4' }, // Updated color
  checked: { backgroundColor: green[500], color: '#FAF8F4' },
  notStarted: { backgroundColor: red[500], color: '#FAF8F4' },
  started: { backgroundColor: blue[500], color: '#FAF8F4' },
};

interface ExamStatusChipProps {
  value?: ExamStatus;
}

const ExamStatusChip: React.FC<ExamStatusChipProps> = ({ value }) => {
  const { t } = useTranslation();

  return (
    <Chip
      label={t(`exam status ${value ?? ExamStatus.sended}`)}
      sx={{
        '& .MuiChip-label': {
          padding: 0,
        },
      }}
      style={{
        ...statusStyles[value ?? ExamStatus.sended],
        borderRadius: '999px',
        padding: '8px 16px',
        fontFamily: 'Mulish, sans-serif',
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '1.4rem',
        fontFeatureSettings: "'liga' off, 'clig' off",
      }}
    />
  );
};

export default ExamStatusChip;
